import LazoErrorService from "@/services/LazoErrorService";
import React from "react";
import { ErrorComponent } from "./ErrorComponent";

interface ErrorBoundaryState {
  hasError: boolean;
}

export interface ErrorDetails {
  message: string;
  stack: string;
  componentStack: string;
  time: string;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
  onGoBack: () => void;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
    this.logErrorToService(error, errorInfo);
  }

  handleGoBack = () => {
    this.setState({ hasError: false });
    this.props.onGoBack();
  };

  //This function logs the error in backend to have more tracing about it
  logErrorToService(error: Error, errorInfo: React.ErrorInfo): void {
    const errorDetails: ErrorDetails = {
      message: error.message,
      stack: error.stack.split("\n")[1].trim(),
      componentStack: errorInfo.componentStack.split("\n")[1].trim(),
      time: new Date().toISOString(),
    };

    LazoErrorService.logError(errorDetails)
      .then((response) => {})
      .catch((loggingError) => {
        console.error("Error while logging to service:", loggingError);
      });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent goBack={this.handleGoBack} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
